import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import InputLabel from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/InputLabel';
import Tooltip from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Tooltip';
import Typography from 'Components/UI/Typography';

import { withStyles } from '@material-ui/core/styles';

import { createBaseStyles } from 'Components/UI/styles';

const styles = theme => ({
  root: {
    ...createBaseStyles(theme),
  },
  label: {
    position: 'absolute',
    top: 0,
    left: 0,
    transform: 'translate(0, 1.5px) scale(0.75)', // Mimic shrink styling on MUI input
  },
  valueRow: {
    display: 'flex',
    alignItems: 'center',
    'label + &': {
      paddingTop: theme.spacing(2),
    },
  },
  valueText: {
    // Copied from MUI https://github.com/mui-org/material-ui/blob/master/packages/material-ui/src/InputBase/InputBase.js
    lineHeight: '1.1876em', // Reset (19px), match the native input line-height
    padding: `${8 - 2}px 0 ${8 - 1}px`,
  },
  spacer: {
    flexGrow: 1,
  },
  readOnlyLabel: {},
});

function ReadOnlyField({
  className,
  classes,
  hasTooltip,
  label,
  value,
  InputLabelProps,
  TooltipProps,
  ValueProps,
  helperText,
  inputProps,
  InputProps,
  readOnly,
  fullWidth,
  rowsMax,
  onAdd,
  onRemove,
  ...rest
}) {
  const valueTypography = (
    <Typography
      className={classes.valueText}
      color="primaryGray"
      variant="h5" // This must always be a block element for an ellipsis to work
      {...ValueProps}
      {...rest}
    >
      {value}
    </Typography>
  );

  return (
    <div
      className={classNames(classes.root, className)}
      {...rest}
    >
      {label && (
        <InputLabel
          className={classes.label}
          {...InputLabelProps}
        >
          {label}
        </InputLabel>
      )}
      <div className={classes.valueRow}>
        {hasTooltip ? (
          <Tooltip
            title={value}
            {...TooltipProps}
          >
            {valueTypography}
          </Tooltip>
        ) : (
          valueTypography
        )}
        <div className={classes.spacer} />
      </div>
    </div>
  );
}

ReadOnlyField.defaultProps = {
  className: '',
  value: null,
  hasTooltip: false,
  InputLabelProps: {},
  TooltipProps: {},
  ValueProps: {},
  label: null,
};

ReadOnlyField.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  hasTooltip: PropTypes.bool,
  value: PropTypes.node,
  InputLabelProps: PropTypes.object,
  TooltipProps: PropTypes.object,
  ValueProps: PropTypes.object,
  label: PropTypes.string,
};

export default withStyles(styles)(ReadOnlyField);
